import React, { CSSProperties, ReactNode } from "react";
import { V2ReportStyle } from "../../styles/V2ReportStyle";
import { PALLETTE } from "../../utils/theme";

interface PageProps {
  children: ReactNode;
  style?: CSSProperties;
}

const Page = ({ children, style }: PageProps) => {
  return (
    <div
      className={"page-margin"}
      style={{
        ...V2ReportStyle.container,
        ...style,

        backgroundColor: PALLETTE.background,
      }}
    >
      {children}
    </div>
  );
};

export default Page;
